import dompurify from "isomorphic-dompurify";

import type { PaymentData } from "@jti/fe-common";
import { useTranslations } from "@jti/ui";

import { useCheckoutV2Configuration } from "@checkout-v2/shared/providers/CheckoutV2ConfigurationProvider";

import styles from "./OrderPaymentMethod.module.scss";

const { sanitize } = dompurify;

type OrderPaymentMethodType = {
  isPayOnDelivery?: boolean;
  paymentMethod?: PaymentData;
};

export const OrderPaymentMethod = ({ isPayOnDelivery = false, paymentMethod }: OrderPaymentMethodType) => {
  const { __ } = useTranslations();
  const checkoutConfiguration = useCheckoutV2Configuration();

  const paymentMethodTranslationKey = paymentMethod?.payment_method ?? paymentMethod?.title;
  const translatedPaymentMethodTitle =
    __(`cart.order.payment_method.${paymentMethodTranslationKey}`, undefined, paymentMethod?.title) ||
    paymentMethod?.title;

  if (isPayOnDelivery) {
    return (
      <div
        data-testid="pay-on-delivery-message"
        dangerouslySetInnerHTML={{
          __html: sanitize(checkoutConfiguration.general.payOnDeliveryMessageText || ""),
        }}
      ></div>
    );
  }

  if (paymentMethod) {
    return (
      <div data-testid="payment-method" className={styles.paymentMethod}>
        {paymentMethod.icon && <img src={paymentMethod.icon} alt="" className={styles.paymentMethodImg} />}
        {translatedPaymentMethodTitle}
      </div>
    );
  }

  return <div>{__("cart.order.payment_method.na")}</div>;
};
